// extracted by mini-css-extract-plugin
export var quillEditor = "_pt-1";
export var variable = "_pt-0";